import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07dee677"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page d-flex-1f d-page-bg" }
const _hoisted_2 = ["onClick", "data"]
const _hoisted_3 = { class: "d-page-listdata-card" }
const _hoisted_4 = { class: "d-flex item-1row" }
const _hoisted_5 = { class: "d-flex-1f title" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "d-flex item-2row" }
const _hoisted_8 = { class: "img-wrap" }
const _hoisted_9 = { class: "d-flex-1f" }
const _hoisted_10 = { class: "desc" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details" }, "查看详情>>", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_badge = _resolveComponent("van-badge")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_app_list = _resolveComponent("app-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_list, {
      onLoadData: _ctx.loadData,
      ref: "appList",
      name: "消息记录"
    }, {
      default: _withCtx((slotProps) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (_ctx.go(item)),
            key: item.id,
            data: item,
            class: "d-swipe-cell"
          }, [
            _createVNode(_component_van_swipe_cell, {
              class: "swipe-cell",
              "stop-propagation": true
            }, {
              right: _withCtx(() => [
                _createVNode(_component_van_button, {
                  square: "",
                  type: "danger",
                  text: "删除",
                  class: "d-full btn-del",
                  onClick: ($event: any) => (_ctx.delNotice(item.id))
                }, null, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_van_badge, {
                        dot: item.isRead == false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.title) + " ", 1)
                        ]),
                        _: 2
                      }, 1032, ["dot"])
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(new Date(item.times).format(
                                            "yyyy-MM-dd HH:mm"
                                        )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_van_image, {
                        width: "100%",
                        height: "100%",
                        alt: "图片加载中...",
                        fit: "cover",
                        src: _ctx.firstImg(item.shopOrder.img)
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(item.contexts), 1),
                      _hoisted_11
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }, 8, ["onLoadData"])
  ]))
}